import { FC, } from "react";
import { Link } from "react-router-dom";
import { Container } from "reactstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { CategoriesTitle } from "../../../constants";
import { CategoriesContentData, CategoriesSettingData } from "../../../data/demo/CarDemo1";
// import { useAppSelector } from "../../../reduxToolkit/hooks";
import { routes } from "../../../routers/routes";
import { CategoryType } from "../../../types/HomeDemo";
import { Image } from "../../../utils";
import CommonHeader from "./CommonHeader";

const Categories: FC<CategoryType> = ({ type, data }) => {
  // const { categoryItem } = useAppSelector((state) => state.product);
  
  return (
    <>
      {/* Car Demo-1 */}
      {type === "car_demo1" && (
        <section className="car-categories-section bg-color section-t-lg-space">
          <Container>
            <CommonHeader contentClass="text-black" title={CategoriesTitle} content={CategoriesContentData} headClass="title-style-2" animation />
            <div className="swiper-wrapper-container">
              {/* Left Button */}
              <button className="car2-category-prev nav-button"><i className="ri-arrow-left-s-line"></i></button>

              <Swiper {...CategoriesSettingData} className="car-categories-slider">
                {data
                  .map((car, index) => (
                    <SwiperSlide key={index}>
                      <div className="categories-box">
                        <Link to={routes.Car.Listing.CarLeftList + `?category=${car.name}`} className="categories-img">
                          <Image src={car?.cateImg?.[0]?.fileUrl} alt={`car-${index + 1}`} className="img-fluid" />
                        </Link>
                        <div className="categories-board">
                          <span>{car.name}</span>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
              </Swiper>

              <button className="car2-category-next nav-button"><i className="ri-arrow-right-s-line"></i></button>
            </div>
          </Container>
        </section>
      )}
    </>
  );
};

export default Categories;
